var render = function render(_c,_vm){return _c('inline-svg',_vm._b({class:_vm.data.staticClass || '',style:({ height: _vm.props.height, width: _vm.props.width }),attrs:{"src":"img/cpu.svg"}},'inline-svg',_vm.data.attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }